import React from 'react'

import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import useSale from 'artkive/hooks/useSale'

import { ActionButton, InfoWrap, SubTitle, Title } from './HeroSection.style'

const Content = () => {
  const isMobile = useMobileBreakpoint()
  const { boxCheckoutUrl } = useSale()

  return (
    <InfoWrap>
      <Title variant='h1'>
        The #1 solution
        <br />
        for preserving and celebrating kids&apos; art!
      </Title>
      <SubTitle variant={isMobile ? 'body1' : 'subtitle1'}>
        We transform your piles of kid art into Kids Art Books and Framed Mosaics.
      </SubTitle>
      <ActionButton
        color='primary'
        variant='contained'
        href={boxCheckoutUrl}
        trackerEvent={GET_BOX_CLICK}
        trackerOptions={{ section: 'home_start_banner' }}
      >
        Get My Box
      </ActionButton>
    </InfoWrap>
  )
}

export default Content
